import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const OOPS = "Oops — let's try that again.";

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) {
    // No server message (network blip, proxy 5xx, crash) → friendly retry prompt.
    if (err?.isAxiosError || err?.request || err?.response) return OOPS;
    return err?.message || OOPS;
  }
  if (typeof detail === "string") return detail;
  return OOPS;
}

export default api;
